import { StateCreator } from 'zustand';

import { GiftingTopUpFormFields } from 'src/components/Gifting/GiftingTopUpForm/types';

import { TopUpWalletSlice } from './types';

const initialState: GiftingTopUpFormFields = {
  pointsAmount: '',
  confirmAuthorised: false,
};

const createTopUpWalletSlice: StateCreator<TopUpWalletSlice> = (set) => ({
  topUpWalletData: initialState,
  setTopUpWalletData(topUpWalletData) {
    set((state) => ({ topUpWalletData: { ...state.topUpWalletData, ...topUpWalletData } }));
  },

  resetTopUpWalletData() {
    set({ topUpWalletData: initialState });
  },
});

export default createTopUpWalletSlice;
